export const REGISTRATION_PAYMENT_STORAGE_KEY =
  "org-registration-payment-status";

export const saveOperatorSession = (payload = {}) => {
  localStorage.setItem("dwt-tok", payload.access_token || "");
  localStorage.setItem("org-name", payload.org_name || "");
  localStorage.setItem("org-id", String(payload.org_id || ""));
  localStorage.setItem("org-email", payload.email || "");
  localStorage.setItem("org-phone", payload.phone || payload.mobile || "");
  localStorage.setItem("org-refferral-code", payload.refferral_code || "");
  localStorage.setItem(
    "org-refferral-count",
    String(payload.refferral_count || 0),
  );

  if (payload.registration_payment_status) {
    localStorage.setItem(
      REGISTRATION_PAYMENT_STORAGE_KEY,
      JSON.stringify(payload.registration_payment_status),
    );
  }
};

export const getStoredRegistrationPaymentStatus = () => {
  try {
    return JSON.parse(
      localStorage.getItem(REGISTRATION_PAYMENT_STORAGE_KEY) || "null",
    );
  } catch (error) {
    return null;
  }
};

export const isRegistrationPaymentPending = (status) =>
  Boolean(status) && !Boolean(status.paid);
